<!-- 安家服务 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <!-- 上传图片 -->
        <div class="cropper-app">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="图片" prop="mainImage">
              <div class="list-img-box">
                <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative'}" v-for="(item,index) in formValidate.photoList" :key="index">
                  <img :style="{width: '210px',height:'297px',marginTop: '3px'}" :src="bindSrc(item)">
                  <i @click="delPhoto(index)" :style="{position:'absolute',color: $store.state.noticeColor,fontSize: '25px',top:'0',right:'-3px',zIndex:'99',cursor:'pointer'}" class="el-icon-error"></i>
                </li>
                <li :style="{marginRight:'10px',whiteSpace:'nowrap',display:'inline-block',padding:'0',position:'relative',float:'left'}">
                  <img v-show="false" :src="formValidate.mainImage" :style="{width:'210px',height:'297px',marginLeft:'10px'}"  alt="自定义图片">
                  <div :style="{width:'210px',height: '297px'}" class="upload-btn" @click="uploadPicture('flagImg')">
                    <i class="el-icon-plus" style="font-size: 30px;"></i><span>添加图片</span>
                  </div>
                </li>
              </div>
              <input type="hidden" v-model="formValidate.mainImage" placeholder="请添加图片">
            </el-form-item>
            <el-form-item label="正文" prop="content" :style="{marginBottom:'0px'}"></el-form-item>
            <div class="edit_container" :style="{width:'100%',height:'370px'}">
              <!-- 图片上传组件辅助，组件内添加v-show=“false”属性，把该组件隐藏起来。-->
              <el-upload class="avatar-uploader" :action="uploadUrl" name="file" :show-file-list="false" :on-success="uploadSuccess" :before-upload="beforeUpload">
              </el-upload>
              <!--新增时输入-->
              <quill-editor v-model="formValidate.content" :content="formValidate.content" ref="myQuillEditor" :options="editorOption"
                            @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"
                            :style="{width:'100%',height:'300px'}"></quill-editor>

            </div>
          </el-form>
          <!-- 剪裁组件弹窗 -->
          <el-dialog title="裁切图片" :visible.sync="cropperModel" width="1110px" center :close-on-click-modal="false" :before-close="handleClose">
            <cropper-image :Name="cropperName" :cropperType="4" @uploadImgSuccess="handleUploadSuccess" ref="child"></cropper-image>
          </el-dialog>
          <!--查看大封面-->
          <el-dialog title="查看大图片" :visible.sync="imgVisible" center>
            <img :src="imgName" v-if="imgVisible" style="width: 100%" alt="查看">
          </el-dialog>
        </div>
        <!-- 保存 -->
        <div :style="{textAlign:'center',marginTop:formValidate.type == 1?'40px':'20px'}">
          <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
          <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  import CropperImage from "../Dialog/CropperImage";
  import { quillEditor } from "vue-quill-editor"; //调用编辑器
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
    ['blockquote', 'code-block'],     //引用，代码块
    [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
    [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下标
    [{ 'indent': '-1'}, { 'indent': '+1' }],     // 缩进
    [{ 'direction': 'rtl' }],             // 文本方向
    [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],     //几级标题
    [{ 'color': [] }, { 'background': [] }],     // 字体颜色，字体背景颜色
    [{ 'font': [] }],     //字体
    [{ 'align': [] }],    //对齐方式
    ['clean'],    //清除字体样式
    ['image','video']    //上传图片、上传视频
  ];

  export default {
    name: 'RelocationService',
    components: {
      CropperImage,
      quillEditor
    },
    data () {
      return {
        formValidate: {
          photoList:[], //图片列表
          mainImage: '',//添加图片
          mainImageSrc: '',//回显图片
          content: "",//文本编辑器内容
          url:"", // 网址
          title: 1,//几个
        },
        ruleValidate: { //图片非空验证
          // mainImage: [
          //   { required: true, message: '请上传图片', trigger: 'blur'}
          // ],
        },
        cropperModel:false,//裁切图片参数弹出框
        cropperName:"",//裁切图片参数图片名称
        imgName: "",//裁切图片参数查看大图src
        imgVisible: false,//裁切图片参数是否查看大图
        editorOption: {
          placeholder: "请在这里输入",
          theme: 'snow', //主题 snow/bubble
          modules:{
            history: {
              delay: 1000,
              maxStack: 50,
              userOnly: false
            },
            toolbar: {
              container: toolbarOptions,
              handlers: {
                image: function (value) {
                  if (value) {
                    // 调用element的图片上传组件
                    document.querySelector('.avatar-uploader input').click()
                  } else {
                    this.quill.format('image', false)
                  }
                }
              },
            }
          }
        },
        uploadUrl:"/api/file/upload",
      }
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      },
    },
    methods: {
      // 拼接页面图片地址
      bindSrc(url){
        return api_url+"/"+url;
      },
      // 删除图片
      delPhoto(index){
        this.formValidate.photoList.splice(index,1);
      },
      //图片设置
      uploadPicture(name){
        this.cropperName = name;
        this.cropperModel = true;
      },
      //图片上传成功后
      handleUploadSuccess (data){
        this.formValidate.mainImageSrc = data[0].path;
        this.formValidate.mainImage = api_url+"/"+data[0].path;
        this.formValidate.photoList.push(this.formValidate.mainImageSrc);
        this.handleClose();
      },
      // 关闭上传弹出框
      handleClose() {
        this.cropperModel = false;
        this.$refs.child.beClose();
      },
      // 转码
      escapeStringHTML(str) {
        str = str.replace(/&lt;/g,'<');
        str = str.replace(/&gt;/g,'>');
        return str;
      },
      // 失去焦点事件
      onEditorBlur(quill) {
        console.log('editor blur!', quill)
      },
      // 获得焦点事件
      onEditorFocus(quill) {
        console.log('editor focus!', quill)
      },
      // 准备富文本编辑器
      onEditorReady(quill) {
        console.log('editor ready!', quill)
      },
      // 内容改变事件
      onEditorChange({ quill, html, text }) {
        console.log('editor change!', quill, html, text)
        this.content = html
      },
      beforeUpload (file) { },
      uploadSuccess (res) {
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill
        // 如果上传成功
        if (res.status === 200) {
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          console.log(res.data[0].path)
          quill.insertEmbed(length, 'image', api_url+"/"+res.data[0].path)
          // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          // 提示信息，需引入Message
          this.$message.error('图片插入失败！')
        }
      },

      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate( (valid) => {
          if (valid) {
            let params = {},title="新增";
            if (this.$route.query.data == undefined){
              params = {
                id:Number(this.formValidate.title) + 1,
                content:this.formValidate.content,
                imageUrl:this.formValidate.photoList.toString().replace(/,/g, '|'),
              }
            } else {
              params = {
                id:this.$route.query.data.id,
                content:this.formValidate.content,
                imageUrl:this.formValidate.photoList.toString().replace(/,/g, '|'),
              }
              title = "编辑";
            }
            this.$api.saveOrUpdateSettleDown({parameter: JSON.stringify(params)}).then(res => {
              if (res.data.status == 200) {
                this.$message({
                  type: 'success',
                  message: title+'成功！'
                });
                this.$router.push('/RelocationServiceManagement');
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/RelocationServiceManagement');
      }
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.title = this.$route.query.data.id;
        this.formValidate.content = this.escapeStringHTML(this.$route.query.data.content);
        this.formValidate.photoList = this.$route.query.data.imageUrl != '' && this.$route.query.data.imageUrl != null?this.$route.query.data.imageUrl.split("|"):[];
      } else {
        this.formValidate.title = this.$route.query.data;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/RelocationServiceManagementOperation.vue